import { getDate, getTime, getYear, set } from 'date-fns';

export function setToday(date: number | Date): number {
  return getTime(set(date, { date: getDate(new Date()), year: getYear(new Date()) }));
}
